module.exports = __webpack_public_path__ + "static/media/poster_General.64c06018.png";